import React from 'react'

const SearchInputSuggestions: React.FunctionComponent = ({ children }) => <div className="w-full p-2">{children}</div>

export default SearchInputSuggestions
